import { HttpClient } from '@angular/common/http';
import { Injectable, inject } from '@angular/core';
import { UrlService } from '@core/services/url.service';
import { WhiteboardUpdate } from '@osc-utils/models/whiteboard-update';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class RedlinesFetcherService {
  readonly #httpClient = inject(HttpClient);
  readonly #urlService = inject(UrlService);

  public fetch(fileId: string, taskId: string): Observable<WhiteboardUpdate[]> {
    const url = this.#urlService.getUrl(`tasks/${taskId}/interactive-isometrics/${fileId}/redlines`);
    return this.#httpClient.get<WhiteboardUpdate[]>(url);
  }
}
